import { DeviceValue, EditorObject } from './responsiveTypes'

const getDeviceObject = (
  object: EditorObject,
  deviceType: DeviceValue | undefined
): EditorObject => {
  if (object && deviceType && object[deviceType]) {
    return { ...object, ...object[deviceType] }
  } else {
    return object
  }
}

export default getDeviceObject
